import { INVOICES_V2 } from 'constants/invoiceServiceV2Flags';
import { isFlagEnabled } from './launchDarkly';
import { CROPWISE_PROXY_URL, CROPWISE_PROXY_V2_URL } from './apiConstants';

/**
 * Routing helpers for the Invoice Service V2 (Java -> Node) migration.
 *
 * Every helper resolves the backend when it is called, not when it is imported, so
 * the axios resources in `utilities/api` can be built once at module load and still
 * send each request to whichever backend `releaseBeInvoicesV2` currently selects.
 */

/** True when invoice requests should go to the Node service. */
export const isInvoicesV2Enabled = (): boolean => isFlagEnabled(INVOICES_V2);

/**
 * Java uses the singular `invoice` for every operation except the list; Node uses
 * the plural `invoices` for all of them.
 */
export const INVOICE_V2_RESOURCE_NAME = 'invoices';

/**
 * Rewrites a `createChildApi` action from the Java path to the Node path, e.g.
 * `invoice/{id}` -> `invoices/{id}` and `invoice/summaries` -> `invoices/summaries`.
 * Idempotent: an action already using the plural form is returned unchanged.
 */
export const remapInvoiceAction = (action: string): string =>
  action.replace(/^invoice(?=\/|$)/, 'invoices');

/** Summaries endpoint for the callers that use raw axios instead of the resources. */
export const getInvoiceSummariesUrl = (): string =>
  isInvoicesV2Enabled()
    ? `${CROPWISE_PROXY_V2_URL}/invoices/summaries`
    : `${CROPWISE_PROXY_URL}/v1/invoice/summaries`;
